import axios from "axios";

export default {
    GetUrlModulePart: () => sessionStorage.evaluationsType != 'dghnoCi' ? sessionStorage.evaluationsType : 'dghno/ci',

    GetData(context, advancedQueryCriteria) {
        let postData = {};
        if (advancedQueryCriteria.Realtional !== null || advancedQueryCriteria.MrAttributes !== null) {
            postData = advancedQueryCriteria;
        }

        return axios({
            url: `${process.env.VUE_APP_API_URL}/${this.GetUrlModulePart()}/patientsList/${context.type}/${context.id}`,
            method: "POST",
            data: postData,
        });
    },
    
    GetMrAttributes() {
        return axios.get(`${process.env.VUE_APP_API_URL}/${this.GetUrlModulePart()}/retrieveIndexedMrAttributes`);
    }, 
}